import { updateBot } from '../api/services/botService';

// Appearance & Branding is stored on the bot record (bot.appearance), so Bot Configuration's live
// preview and the visitor widget read exactly what is saved here — there is no separate key.
export const APPEARANCE_EVENT = 'chatbizz_appearance_updated';

export const DEFAULT_APPEARANCE = {
  launcher: 'Round Blue', position: 'Bottom right', launcherSize: 58,
  botName: 'ChatBizz AI', description: 'Advanced AI Support Chat Bot',
  primary: '#007BFF', secondary: '#00D4FF', font: 'Poppins',
  avatar: '', logo: '', headerText: 'ChatBizz AI', headerStatus: 'Online',
  welcome: "Hi! I'm ChatBizz AI 👋\nHow can I help you today?",
  showName: true, widgetPosition: 'bottom-right', widgetWidth: 380, widgetHeight: 620,
  desktopOffsetX: 24, desktopOffsetY: 24, mobileWidth: 340, mobileHeight: 560,
};

export const withDefaults = (appearance) => ({ ...DEFAULT_APPEARANCE, ...(appearance || {}) });

/** Persists the appearance on the bot and tells any open widget in this tab to re-render. */
export async function saveAppearance(botId, value) {
  const bot = await updateBot(botId, { appearance: withDefaults(value) });
  const next = withDefaults(bot.appearance);
  window.dispatchEvent(new CustomEvent(APPEARANCE_EVENT, { detail: { botId, appearance: next } }));
  return { next, bot };
}
